var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div style=\"max-width: 108px; min-width: 45px; margin: 0 4px 4px; display: inline-block;\"><div ng-include=\"$ctrl.templateUrl\" ng-init=\"sl=$ctrl.layer\"></div></div>";
var id1="design-layer-field.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;